import { css } from "@compiled/react";

import { Icon } from "../../../libraries/wpl/foundations/src";

const listItemStyles = css({
    "listStyle": "none",
    "fill": "#6554c0",
    "paddingLeft": "20px",
    "marginTop": 0,

    "li:first-child p": {
        marginBlockStart: 0
    },

    "li": {
        "marginBottom": "24px",
        "position": "relative",
        "listStyleType": "none",
        "marginLeft": "-20px",
        "minHeight": "15px",
        "paddingLeft": "32px",

        ".icon": {
            display: "inline-block",
            marginInlineEnd: "16px",
            position: "absolute",
            width: "16px",
            height: "16px",
            insetBlockStart: "4px",
            insetInlineStart: "3px",

            svg: {
                display: "inline-block",
                width: "16px",
                height: "16px",
                fill: "black"
            }
        },

        "p": {
            fontSize: "1rem",
            lineHeight: "1.5rem"
        }
    }
});

type ChecklistProps = {
    listItems: (string | JSX.Element)[];
};

const Checklist = ({ listItems }: ChecklistProps) => {
    return (
        <ul css={listItemStyles}>
            {listItems.map((listItem, index) => (
                <li key={index}>
                    <Icon name="checkmarkbasic" color="p300" size="xs" />
                    <p>{listItem}</p>
                </li>
            ))}
        </ul>
    );
};

export default Checklist;
